import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '1. ¿Necesito tener muchos seguidores?',
  a: 'Absolutamente no. El ugc no se basa en tu cantidad de seguidores. Las marcas te contratan por tu habilidad para crear contenido auténtico. NO por tu audiencia.'
}, {
  q: '2. No tengo experiencia previa',
  a: 'Podés comenzar 100% desde cero. Te enseño cómo armar tu portafolio y cómo presentarte de forma profesional ante las marcas, aunque no tengas colaboraciones anteriores.'
}, {
  q: '3. ¿Qué necesito para empezar a crear contenido UGC?',
  a: 'Sólo necesitas un celular con cámara, ganas de aprender y conexión a internet. No hace falta tener equipo profesional para empezar. También te doy una lista de apps gratuitas y recursos para editar, grabar y presentar tu contenido de forma pro.'
}, {
  q: '4. ¿Puedo vivir 100% de esto?',
  a: 'Sí, es totalmente posible vivir del contenido UGC si lo tratás como un negocio. En este curso te enseño la fórmula más sencilla que a mi me permitió comenzar desde cero y tener resultados REALES desde el primer mes, igual que mis alumnas.'
}, {
  q: '5. ¿Necesito mostrarme en cámara?',
  a: 'No necesariamente al principio. Pero si con el tiempo. Hay muchos estilos de contenido UGC donde no hace falta mostrar tu cara: voice overs, manos en acción, POVs, unboxings, tutoriales, reseñas. ¡Te enseño todas las opciones! Pero quiero aclararte, que siempre LO MEJOR será que te muestres tal y como eres, auténtica y natural.'
}, {
  q: '6. ¿Sirve esto si soy de cualquier provincia de Argentina, o de otro país?',
  a: '¡Sí! El contenido UGC es un modelo global. Podés trabajar con marcas locales o internacionales desde donde estés. Te enviarán los productos a tu domicilio. Además, podrás cobrar de forma fácil y segura a través de plataformas como PayPal, MercadoPago o Wise.'
}, {
  q: '7. ¿Cuánto se puede cobrar por contenido UGC?',
  a: 'Depende del tipo de contenido, el uso que le dé la marca (orgánico vs. publicitario), tu experiencia y tu tiempo. Pero podes comenzar cobrando de $50 a $100 usd por tu contenido UGC.'
}, {
  q: '8. ¿Puedo empezar ahora?',
  a: '¡Sí! Una vez que haces tu compra, accedes de inmediato al contenido y podes empezar a crear y ofrecer tus servicios desde hoy mismo.'
}, {
  q: '9. ¿Qué pasa si tengo dudas?',
  a: 'Podrás resolver tus dudas y preguntas dentro del grupo privado de Whatsapp y también podrás compartir tus avances, junto a otras mujeres que están en el mismo camino que vos.'
}, {
  q: '10. ¿Cuáles son los medios de pagos disponibles?',
  a: 'MercadoPago, Tarjeta de Credito VISA, MASTERCARD, transferencia Bancaria en ARS, transferencia en USD.'
}, {
  q: '11. ¿Tenés otra pregunta que no aparece acá?',
  a: 'Escribime al Whatsapp o envíame un mensaje por DM en Instagram @entualma.viajes y con gusto te ayudo. Estoy acá para acompañarte en este camino 🙌✨'
}];
export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="px-6 py-12 flex flex-col items-center bg-brand-navy relative overflow-hidden mt-[50px] mb-[50px]" data-id="element-115">
      {/* Ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-[#D98BAF]/10 blur-[140px] rounded-full pointer-events-none" data-id="element-116" />

      <h2 className="font-black text-3xl md:text-5xl text-center uppercase tracking-tight mt-[20px] mb-[40px] relative z-10 text-[#D98BAF]" style={{
      fontFamily: "'Inter', sans-serif",
      fontWeight: 900
    }} data-id="element-117">
        Preguntas Frecuentes
      </h2>

      <div className="w-full space-y-4 max-w-4xl mx-auto px-4 relative z-10" data-id="element-118">
        {faqs.map((faq, idx) => {
        const isOpen = openIndex === idx;
        return <div key={idx} className="border-b border-[#D98BAF]/20 pb-4" data-id="element-119">
              <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full py-4 flex items-center justify-between text-left group gap-4" data-id="element-120">
                <span className="font-serif italic font-bold text-[#D98BAF] text-xl md:text-2xl leading-tight pr-4 group-hover:text-white transition-colors" data-id="element-121">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="text-[#D98BAF] shrink-0 drop-shadow-[0_0_8px_rgba(217,139,175,0.3)]" data-id="element-122">
                  <ChevronDown size={26} strokeWidth={2.5} data-id="element-123" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-124">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-125">
                    <div className="pb-4 text-white/80 font-serif text-lg md:text-xl leading-relaxed pt-2" data-id="element-126">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}